var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 279,
    width: 38,
    height: 38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9523.34,
    y: -0.171573,
    width: 371429,
    height: 371429
  })), /*#__PURE__*/React.createElement("image", {
    width: 41,
    height: 41,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAYeSURBVFhH3Zl7SNRZFMfVNMcyTGzK0lwna3w2WLlorJhCibm4pbFmEP7TZvSE0Nr+KKVaM3Bh163tXSQLStKLXrslslQUBLW0PcletEhFLyp6Wd373Xvu75gzrTPzm9T+2A9cZOaee+537j333Id+/3tkY6NdTp78nYiJ+UEkJzeLiIhmERjYLAYObBZxcc0iPn69zMurkGvWfMlNPg+yoWGIKChYKWy2ywgMBPz8vBd/f4ioqHsiK2udrKkZza56HpSV9RPZ2T+JyEihOw4IAMaOBSoqgKYm4PJl4PFj4O1b4Nkz4OZN4NAhYNUqIDsbCA42BPfvD4wZ0yTLy79g1z2DLCz8Wom7qzsJDQUWLQKuXYNPPHgA1NQAw4ZpsSok2mVu7vfcRfcQ48evEUFBEn36AKWlRmfd4fVrYOVKY0QpDByOYypug7k735C7doWISZOayRGsVuDwYe6lh7h6FXA4jFEdPfqOrK31ffq1QJrehATg1i323MO8eAEUFBhC4+P/kfX1Edy9d0RGxio9gvHxwMOH7LGXoIVWWGgItdn+kK2t3qdelpRMgsUCREQA16+zp17m5UsgLU3HqMzMrGIpXSPr6oJVYm7T6WXfPvbwmaCQCguDCA0VctasRJb0X0R+/o86DktKuKUHVqww0snQoa4lOhpITgaKioC1a40FIiU38sKGDUYuTUs7y5JckSdOWNWu0I6QEKCtjVt5ICrKcOit0K5Ei+POHW7ogXfvgJQU3UZtpfksrROkp5dpp2Vl3MILkZGuYmihUZjQX+fvO8qgQcCZM9zYAw0N2l7t/Q0srRORlPS37uD8ebb2grPIIUOA27eNGaARO34cmDcPelY6bKjQ6N+/zw7c8OaN/kHCahVy797OlET5Sa/opCS2NIGzSIrN9++5womLF404dRZK4r0xZ462ldnZU1ii+pSZOVU7WLiQrUxgRiTR0gK9pXbYDhgAPH3KlW7Ys0fbqin/mSWqkYyNrdIOGhvZygRmRdLKHjeu05bKkSNc6YZ797SdmvI/WaKKx7S0Ft3YbDwSZkUSy5d32lKpruYKN5Cv8HCIhATBEpVIq9UQ+egRW5nAF5E7d7qKXLyYK9xAo6/ODCI83ElkUJAhsr2drUzgi8jdu11FLljAFR5QIaJ0OYkMCTFEvnrFFibwReT27a4ily3jCjfQSKamQlgsTiKjow2RFLBm8UXk0qWuItet4wo3CAGMHKlzJUvUC2e/bnzqFFuZwKxI+p62ug5b2jC87Tx0fOvXD7Dbn7JElYJSU1doB1u2sJUJzIo8etR1qxw82LhCeKK1VduK2NgWlqhE5udnaQczZ7KVCcyIpJTmbEdlyRKu9MC2bdpW2u2VLJFawl8fAGgLo5OIGZw7p9EhQVeuAOfOAfv3A7NnGyegDhsqcXHA8+fswANTpujRlwUFX7FEA5GSclA78rYbdPDxCHkrw4ebuwZTrlbnCHX4pl/jz/IM5PTpRdpZbq5h7A2z58mgIKC42HzmWL1at1OL+ReW1gmamvqIxMQ2HeSnT3MLD1RVAaNG6VThUhITgYwMYMYMoK7O3AG6gydPjGNaWJiQGzeOYmmuyOLiUn1wpQOB2djsSebPN0YxPX07S+oaul/oaaI7zOfk2DF9slcbywts3jyI5XSNLC2NUpn+tT4DHjjAHnqZGzf0FVr07StlYeE3LMUzKqYm6oxPj1MnT7KnXoJilmJbjaJ0ODzfuT9GjWiVXpkklk4xvcGFC0BMjM6JIifnd/VNEHdvHiW0Qk3BWz319A7pyynJE7Q77dihZ0oEBEiRlfWbyi59uVvfkdOmTRahoW16MVGKOXjw01c+HcHOngVycoxVbLG8kTk5S7ir7iFra23Cbt/z4UJFT3abNhmPWWZeJ+j1jC5XtFHw3Vyt4r9keXkWd9FzyLlzC4TDceGDWIpZepKm/LZ+vfEsTe+YFMNbtxqHiQkTjAdTsqcUY7O1yalT5+LSpU+fXjPI6uoJSuyvYsSIuyIwUGoB7ooh7BW9SKgfWaTGtXfFdYWsr7dTypITJ1bKmJhKabFUysjISpmRUYm8vG9VqHTz3yN+fv8C5l9AO9SH/DYAAAAASUVORK5CYII=",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0314825-0.0892392 361905-0.0892392 361905 361905-0.03125 361905Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-559 -279)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000105 0 0 0.000105 559 279)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "matrix(8826.95 0 0 8826.95 -0.0314825 -0.0892392)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.72d89687997038d6540c1949d35269a1.svg";
export { ForwardRef as ReactComponent };